import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-frequently-asked-questions-button',
    templateUrl: './frequently-asked-questions-button.component.html',
    styleUrls: ['../../nav-bar.component.scss'],
    standalone: false
})
export class FrequentlyAskedQuestionsButtonComponent {
  faqUrl = environment.clearsignFaqUrl;
}
